import { App } from 'vue';
import NavigationService from "@/services/NavigationService";
import { RouteKey } from "@/config/routes";

export interface NavigationInterface {
    buildRouteUrl: (route: RouteKey, parameters?: Record<string, any>) => string,
}

const navigation: NavigationInterface = {
    buildRouteUrl: NavigationService.buildRouteUrl,
};

export function initNavigation(app: App) : App {
    app.config.globalProperties.$navigation = navigation;

    return app;
}
